"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebJsonLoader = void 0;
var WebJsonLoader = /** @class */ (function () {
    function WebJsonLoader(_path, _onCompleteCb) {
        this._path = _path;
        this._onCompleteCb = _onCompleteCb;
        this._hasError = false;
        this._path = _path;
        this._onCompleteCb = _onCompleteCb;
    }
    WebJsonLoader.prototype.load = function () {
        var _this = this;
        var request = new XMLHttpRequest();
        if (request.overrideMimeType) {
            request.overrideMimeType("application/json");
        }
        request.addEventListener("readystatechange", function (e) { return _this.onJsonLoaded(e); });
        request.open("GET", this._path, true);
        request.send(null);
    };
    WebJsonLoader.prototype.onJsonLoaded = function (e) {
        var request = e.target;
        if (request.readyState == 4) {
            if (request.status == 200 || request.status == 0) {
                try {
                    this.onComplete(JSON.parse(request.responseText));
                }
                catch (e) {
                    this.onComplete("");
                }
            }
            else {
                this.onComplete("");
            }
        }
    };
    WebJsonLoader.prototype.onComplete = function (json) {
        this._onCompleteCb(json, this._hasError);
    };
    return WebJsonLoader;
}());
exports.WebJsonLoader = WebJsonLoader;
